import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-magic-uses-soul',
  templateUrl: './magic-uses-soul.component.html',
  styleUrls: ['./magic-uses-soul.component.css']
})
export class MagicUsesSoulComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
